import {Component, OnInit} from '@angular/core';
import {changeFirstPassForm} from '../../../Assets/angular/assets/data/forms/change_first_pass_form';

@Component({
    selector: 'app-change-first-password',
    templateUrl: './change-first-password.component.html',
    styleUrls: ['./change-first-password.component.scss']
})
export class ChangeFirstPasswordComponent implements OnInit {

    changeFirstPassForm: Array<object>;

    constructor() {
        this.changeFirstPassForm = changeFirstPassForm;
    }

    ngOnInit(): void {
    }

}
